import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

/** Hides storefront header/footer on admin. No top padding — transparent nav overlays content. */
const StoreChrome: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  const isCheckout = pathname.startsWith('/checkout');

  return (
    <>
      {!isAdmin && <Header />}
      <main className={isAdmin || isCheckout ? 'min-h-screen' : undefined}>
        {children}
      </main>
      {!isAdmin && <Footer />}
    </>
  );
};

export default StoreChrome;
